import AuthStore from './domain/AuthStore';
import LikuStore from './domain/LikuStore';
import MotionStore from './domain/MotionStore';
import MqttStore from './domain/MqttStore';
import AlarmStore from './domain/AlarmStore';
import ModeStore from './ui/ModeStore';
import VideoStore from './ui/VideoStore';
import InteractiveStore from './domain/InteractiveStore';
import BirthdayStore from './domain/BirthdayStore';
import MetaverseStore from './domain/MetaverseStore';
import VideoV2Store from './ui/VideoV2Store';
import ContentV2Store from './domain/ContentV2Store';
import ContentStore from './domain/ContentStore';
import StorageStore from './domain/StorageStore';
import GreetStore from './domain/GreetStore';

// import UiStore from './ui/UiStroe';

class RootStore {
	constructor() {
		this.authStore = new AuthStore(this);
		this.likuStore = new LikuStore(this);
		this.motionStore = new MotionStore(this);
		this.mqttStore = new MqttStore(this);
		this.modeStore = new ModeStore(this);
		this.videoStore = new VideoStore(this);
		this.videoV2Store = new VideoV2Store(this);
		this.interactiveStore = new InteractiveStore(this);
		this.birthdayStore = new BirthdayStore(this);
		this.metaverseStore = new MetaverseStore(this);
		this.alarmStore = new AlarmStore(this);
		this.contentStore = new ContentStore(this);
		this.contentV2Store = new ContentV2Store(this);
		this.storageStore = new StorageStore(this);
		this.greetStore = new GreetStore(this);
		// this.uiStore = new UiStore(this);
	}
}

export default RootStore;
